<template>
  <div class="recent-activity">
    <custom-panel>
      <template #title>最近动态</template>
      <template #default>
        <dv-scroll-board :config="config" v-if="dataLoaded"/>
      </template>
    </custom-panel>
  </div>
</template>
<script>
import CustomPanel from '../custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      config: {
        headerBGC: 'transparent',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        header: ['实体店', '动态', '日期'],
        data:
          [
            /* ['4402038026', '检查', '2025-3-24'],
            ['4402037787', '检查', '2025-3-24'],
            ['4402029140', '整改', '2025-3-24'],
            ['4402026071', '检查', '2025-3-24'],
            ['4402002323', '检查', '2025-3-24'],
            ['4402040298', '检查', '2025-3-23'],
            ['4402002635', '整改', '2025-3-23'],
            ['4402037761', '整改', '2025-3-23'],
            ['4402039817', '检查', '2025-3-23'],
            ['4402038988', '检查', '2025-3-23'] */
          ]
      }
    }
  },
  created () {
    this.getZuiJinDongTai()
  },
  methods: {
    async getZuiJinDongTai () {
      const res = await request.get('/common/zui-jin-dong-tai')
      this.config.data = res.data.map(item => {
        return [
          item.shiTiDianBianMa,
          item.dongTai,
          item.riQi
        ]
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getZuiJinDongTai()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.recent-activity {
  height: 100%;
  .border-bolder {
    padding: 2px;
    border: solid #036ae0 1px;
    border-radius: 5px;

    .border-lighter {
      border: solid #036ae0 2px;
      border-radius: 5px;

      .title {
        line-height: 30px;
        height: 30px;
        color: #5ac9f8;
        font-size: 16px;
        text-align: center;
        background-image: url('@/assets/title-background-img.png');
        background-repeat: no-repeat;
        background-size: 200px 30px;
        background-position: center;
      }
    }
  }
}
</style>
